import * as React from 'react';

import Text, { TextColor, TextWeight } from 'components/Text';

type Props = {
  children?: string;
  success?: boolean;
  failure?: boolean;
};

export default function StatusText(props: Props) {
  const { success, failure, children } = props;
  let color: TextColor = 'pitch';
  let weight: TextWeight = 'normal';
  if (success) {
    color = 'shamrock';
  } else if (failure) {
    color = 'lava';
    weight = 'semibold';
  }
  return (
    <Text weight={weight} color={color} capitalize>
      {children}
    </Text>
  );
}
